import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@app/core/graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    PakmailShipmentStatus,
    CreatePakmailShipmentStatusInput,
    UpdatePakmailShipmentStatusInput,
    DeletePakmailShipmentStatusInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class PakmailShipmentStatusService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPakmailShipmentStatuses(): Promise<PakmailShipmentStatus[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPakmailShipmentStatuses
                })
            ).data.listPakmailShipmentStatuses.items;
            if (data) return data as PakmailShipmentStatus[];
        } catch (error) {
            console.error('Error finding listPakmailShipmentStatuses:', error);
            return null;
        }
    }

    async createPakmailShipmentStatus(
        input: CreatePakmailShipmentStatusInput
    ): Promise<PakmailShipmentStatus> {
        try {
            const pakmailShipmentStatus = (
                await this.amplifyClient.graphql({
                    query: mutations.createPakmailShipmentStatus,
                    variables: {
                        input
                    }
                })
            ).data.createPakmailShipmentStatus;
            if (pakmailShipmentStatus)
                return pakmailShipmentStatus as PakmailShipmentStatus;
        } catch (error) {
            console.error('Error creating pakmailShipmentStatus:', error);
            return null;
        }
    }

    async updatePakmailShipmentStatus(
        input: UpdatePakmailShipmentStatusInput
    ): Promise<PakmailShipmentStatus> {
        try {
            const pakmailShipmentStatus = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePakmailShipmentStatus,
                    variables: {
                        input
                    }
                })
            ).data.updatePakmailShipmentStatus;
            if (pakmailShipmentStatus)
                return pakmailShipmentStatus as PakmailShipmentStatus;
        } catch (error) {
            console.error('Error creating PakmailShipmentStatus:', error);
            return null;
        }
    }

    async deletePakmailShipmentStatus(
        input: DeletePakmailShipmentStatusInput
    ): Promise<PakmailShipmentStatus> {
        try {
            const pakmailShipmentStatus = (
                await this.amplifyClient.graphql({
                    query: mutations.deletePakmailShipmentStatus,
                    variables: {
                        input
                    }
                })
            ).data.deletePakmailShipmentStatus;
            if (pakmailShipmentStatus)
                return pakmailShipmentStatus as PakmailShipmentStatus;
        } catch (error) {
            console.error('Error deleting pakmailShipmentStatus:', error);
            return null;
        }
    }
}
